import { useQuery } from '@tanstack/react-query';
import { fetchQuestions } from '../../VendorsApis';

export const useQuestionnaireData = (questionnaireId) => {
    const query = useQuery({
        queryKey: ['questions', questionnaireId],
        queryFn: () => fetchQuestions(questionnaireId),
        enabled: !!questionnaireId,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    });

    // تحويل الداتا لـ Groups (Sections)
    const groupedSections = query.data ? Object.values(
        query.data.reduce((acc, item) => {
            const sectionName = item?.pirm_addon__Question__r?.pirm_addon__Template__r?.Name || "General";
            if (!acc[sectionName]) acc[sectionName] = [];
            acc[sectionName].push(item);
            return acc;
        }, {})
    ) : [];

    return { ...query, rawQuestions: query.data, groupedSections };
};